import React from "react";
import styled from "styled-components";

const Layout = () => {
  return (
    <LayoutContainer>
      <img
        style={{ width: "100%", minWidth: "500px" }}
        src={require("../../assets/images/park_layout.png")}
        alt="park_layout"
      />
    </LayoutContainer>
  );
};

export default Layout;
const LayoutContainer = styled.div`
  width: 100%;
  background: #39aca6;
  overflow-x: auto;
`;
